import { CallAPI } from "../../apiManager/ApiCall";
import {
  translateTitleURL,
  translateSubTitleURL,
} from "../../apiManager/APIConfig";

/**
 * Trigger AI translation of ONE parent catalogue Title (histology /
 * embryology / anatomy / 3D) into every supported app locale. The
 * service translates both the title text AND the long-form
 * description (body) that the mobile app shows above the 3D viewer.
 *
 * **UPSERT semantics** — re-running OVERWRITES any existing
 * per-locale localization rows for this title. That's how the
 * "click again to refresh translations" flow works.
 *
 * Resolves to the raw backend payload:
 *   {
 *     status, message, appLangs,
 *     entityType: "Title",
 *     entityId, sourceLang, targetLangs,
 *     results: [{ lang, action: "created"|"updated" }],
 *     created, updated
 *   }
 */
export const translateTitleCall = async (titleId) => {
  if (!titleId) return { status: 400, message: "Missing title id." };
  return CallAPI({
    url: translateTitleURL,
    method: "POST",
    body: { title_id: titleId },
  });
};

/**
 * Trigger AI translation of ONE SubTitle / slide entry into every
 * supported app locale. The service translates both the card label
 * (title) and the description (body) that surfaces in the mobile
 * app's "About this slide / model" overlay.
 *
 * **UPSERT semantics** — re-running OVERWRITES any existing
 * per-locale localization rows for this subtitle.
 *
 * Resolves to the raw backend payload (same shape as
 * `translateTitleCall`, with `entityType: "SubTitle"`).
 */
export const translateSubTitleCall = async (subtitleId) => {
  if (!subtitleId) return { status: 400, message: "Missing subtitle id." };
  return CallAPI({
    url: translateSubTitleURL,
    method: "POST",
    body: { subtitle_id: subtitleId },
  });
};
